import {
    checkFeatureFlagGate,
    featureFlags
} from "@/utils/feature-flags/index.ts";

import { PlanLimitConfigs, BillingCycleConfig } from "../common.ts";

export const JIRA_DEFAULT_BILLING_CYCLE = "MONTHLY";
export const JIRA_DEFAULT_UNIT_COUNT = 300;

export const JIRA_MIN_ENTERPRISE_USER_COUNT = 801;

export const jiraOfferingSkus = {
    free: "jira-software-free",
    standard: "jira-software-standard",
    premium: "jira-software-premium",
    enterprise: "jira-software-enterprise-sku"
} as const;

export const jiraOfferingSkusArray = Object.values(jiraOfferingSkus);

export const getSignupLimit = () => {
    return checkFeatureFlagGate(featureFlags.gwp6830JiraPricing100KUserLimit)
        ? 100_000
        : 50_000;
};

export const jiraPlanLimitConfigs = (): PlanLimitConfigs[] => {
    const signupLimit = getSignupLimit();
    return [
        {
            planName: "Free",
            offeringSku: jiraOfferingSkus.free,
            recommendationLimit: 0,
            signupLimit
        },
        {
            planName: "Standard",
            offeringSku: jiraOfferingSkus.standard,
            recommendationLimit: 10,
            signupLimit
        },
        {
            planName: "Premium",
            offeringSku: jiraOfferingSkus.premium,
            recommendationLimit: 250,
            signupLimit
        },
        {
            planName: "Enterprise",
            offeringSku: jiraOfferingSkus.enterprise,
            recommendationLimit: 5000,
            signupLimit
        }
    ];
};

export const jiraBillingCycleConfig: BillingCycleConfig = {
    monthly: true,
    annual: true
};
